var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between"},_vm._l((_vm.chars),function(c,i){return _c('div',{key:i,domProps:{"innerHTML":_vm._s(c)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }